export function Footer() {
  return (
    <footer className="relative mt-12 border-t-2 border-witch/40 bg-void/80 backdrop-blur-sm">
      <div className="mx-auto max-w-[1400px] px-4 md:px-8 py-10 grid md:grid-cols-3 gap-8">
        <div>
          <div className="flex items-center gap-2">
            <img src="/cauld.png" alt="" className="pixelated w-8 h-8" />
            <span className="font-display text-[10px] text-bone tracking-tight">
              CAULDRON<span className="text-witch">·</span>DEV
            </span>
          </div>
          <p className="mt-3 font-terminal text-sm text-aura/70 max-w-xs">
            Independent web studio. Hand-coded sites &amp; apps for founders, studios, and the
            occasional weirdo.
          </p>
        </div>
        <div>
          <div className="font-display text-[10px] text-mystic uppercase tracking-widest mb-3">
            Sections
          </div>
          <ul className="space-y-1.5 font-pixel text-base text-aura/85">
            <li><a href="#home" className="hover:text-bone pointer">Home</a></li>
            <li><a href="#services" className="hover:text-bone pointer">Services</a></li>
            <li><a href="#work" className="hover:text-bone pointer">Work</a></li>
            <li><a href="#about" className="hover:text-bone pointer">About</a></li>
            <li><a href="#contact" className="hover:text-bone pointer">Contact</a></li>
          </ul>
        </div>
        <div>
          <div className="font-display text-[10px] text-mystic uppercase tracking-widest mb-3">
            Channels
          </div>
          <ul className="space-y-1.5 font-pixel text-base text-aura/85">
            <li><a href="mailto:hello@cauldrondevelopment.io" className="hover:text-bone pointer">hello@cauldrondevelopment.io</a></li>
            <li><a href="#contact" className="hover:text-bone pointer">Contact form →</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t-2 border-bruise px-4 md:px-8 py-3 flex flex-wrap justify-between gap-3 max-w-[1400px] mx-auto font-terminal text-xs text-mystic">
        <span>© {new Date().getFullYear()} Cauldron Dev. Made with care.</span>
        <span>v0.1.0 ▪ pixel-perfect since MMXXIV</span>
      </div>
    </footer>
  );
}
